import * as React from "react";
import {useCartContext} from "../../../../cart/CartContextProvider/CartContextProvider";
import {PurchaseButtonProps} from "./PurchaseButtonProps";
import DefaultPurchaseButton from "./DefaultPurchaseButton";

/* Apple Pay purchase in summary view */
const ApplePayPurchaseButton: React.FC<PurchaseButtonProps> = ({purchaseButtonErrors}) => {
  const {appleData} = useCartContext().viewState;

  return (
    <DefaultPurchaseButton
      purchaseButtonErrors={purchaseButtonErrors}
      paymentInfos={appleData}
      occurrence="Apple Pay Summary Purchase Button"
    />
  );
};

export default ApplePayPurchaseButton;
